/*
 * cart.js
 * Refatoração do carrinho AJAX dinâmico sem delays
 * Mantém offcanvas atualizado, badge de quantidade e spinner nos inputs
 * Integra Formulário de Orçamento sem tocar no HTML
 * Adiciona máscara e restrição de CNPJ com prevenção de duplicação
 * Gerencia transição de botão Finalizar Orçamento entre telas
 */

;(function($) {
  'use strict';

  const baseUrl = window.baseUrl || '';

  // Phone mask function
  function maskPhone(value) {
    // Remove all non-digit characters
    value = value.replace(/\D/g, '');

    // Limit to max 11 digits (2 for area code + 9 for number)
    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    if (value.length <= 10) {
      return value.replace(/(\d{2})(\d{4})(\d{0,4})/, function(match, p1, p2, p3) {
        return '(' + p1 + ') ' + p2 + (p3 ? '-' + p3 : '');
      });
    } else {
      return value.replace(/(\d{2})(\d{5})(\d{0,4})/, function(match, p1, p2, p3) {
        return '(' + p1 + ') ' + p2 + (p3 ? '-' + p3 : '');
      });
    }
  }

  // ===================== Helpers =====================
  function getCsrf() {
    return $('meta[name="csrf-token"]').attr('content');
  }

  function initSpinner(scope) {
    scope.find("input[type='number']:not(.spinner-initialized)")
      .each(function() {
        $(this).inputSpinner();
        $(this).addClass('spinner-initialized');
      });
  }

  function showAlert(target, type, message) {
    const alertEl = $(
      `<div class="alert alert-${type} alert-dismissible fade show" role="alert">
         ${message}
         <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Fechar"></button>
       </div>`
    );
    $(target).empty().append(alertEl);
    setTimeout(() => alertEl.fadeOut(300, () => alertEl.remove()), 2000);
  }

  function updateCartCount(count) {
    $('.qtd-badge').text(count);
    $('#finishOrc').toggleClass('disabled', count === 0);
  }

  // ===================== Cart AJAX =====================
  function loadCount() {
    return $.post({ url: baseUrl + '/load-cart-data', headers: { 'X-CSRF-TOKEN': getCsrf() } });
  }

  function loadCartView() {
    return $.post({ url: baseUrl + '/load-cart-view', headers: { 'X-CSRF-TOKEN': getCsrf() } });
  }

  function refreshCountUI() {
    loadCount().done(data => updateCartCount(data.count));
  }

  function refreshOffcanvas() {
    loadCartView().done(html => {
      const container = $('#screenCarrinho').html(html);
      initSpinner(container);
    });
  }

  function bindAddToCart() {
    $(document).on('click', '.add-to-cart', function(e) {
      e.preventDefault();
      const btn = $(this).prop('disabled', true).html('<div class="spinner-border w-6" role="status"><span class="visually-hidden">Loading...</span></div>');
      const form = btn.closest('.shop-group');
      $.post({ url: baseUrl + '/add-to-cart', data: form.serialize(), headers: { 'X-CSRF-TOKEN': getCsrf() } })
        .done(() => {
          btn.html('<svg class="w-6" fill="currentColor" xmlns="http://www.w3.org/2000/svg" id="mdi-check" viewBox="0 0 24 24"><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>');
          refreshOffcanvas();
          refreshCountUI();
        })
        .fail(err => console.error('Erro addToCart:', err))
        .always(() => btn.prop('disabled', false));
    });
  }

  function bindUpdateQuantity() {
    $(document).on('change', '.input-cart-update', function() {
      const input = $(this);
      const oldVal = input.data('old');
      const form = input.closest('.cart-update');
      $.post({ url: baseUrl + '/update-cart', data: form.serialize(), headers: { 'X-CSRF-TOKEN': getCsrf() } })
        .done(resp => {
          if (resp.success) {
            showAlert('.alert-render', 'success', 'Quantidade atualizada!');
            input.data('old', input.val());
          } else throw new Error('Falha no servidor');
        })
        .fail(() => {
          input.val(oldVal);
          showAlert('.alert-render', 'danger', 'Erro ao atualizar quantidade.');
        });
    });
  }

  function bindRemoveItem() {
    $(document).on('click', '.btn-remove-item', function() {
      const btn = $(this).prop('disabled', true);
      const id = btn.data('id');
      $.post({ url: baseUrl + '/remove-item', data: { _token: getCsrf(), cd_prod: id } })
        .done(resp => {
          if (resp.success) {
            refreshOffcanvas();
            refreshCountUI();
          }
        })
        .fail(err => console.error('Erro removeItem:', err))
        .always(() => btn.prop('disabled', false));
    });
  }

  // ===================== Footer & Form Submit =====================
  function bindFinishOrc() {
    const finishBtn = $('#finishOrc');
    const form = $('.carrinhoForm');
    const screenCarrinho = $('#screenCarrinho');
    const screenOrcamento = $('#screenOrcamento');
    const footer = $('.offcanvas-footer');
    $(document).on('click', '#finishOrc', function(e) {
      if (!finishBtn.hasClass('in-form')) {
        e.preventDefault();
        screenCarrinho.addClass('d-none');
        screenOrcamento.removeClass('d-none');
        // move botão para dentro do form
        const btnWrapper = $('<div class="col-12 text-end mt-3"></div>');
        finishBtn
        .detach()
        .addClass('in-form')
        .attr('type', 'submit')
        .appendTo(btnWrapper);
        footer.addClass('d-none');

        form.append(btnWrapper);
      }
      // se já é submit, o click submete naturalmente
    });
    $(document).on('click', '#backToCarrinho', function(e) {
      e.preventDefault();
      screenOrcamento.addClass('d-none');
      screenCarrinho.removeClass('d-none');
      // restaurar botão
     const btnWrapper = finishBtn.closest('.col-12');
        btnWrapper.remove(); // remove o wrapper todo

        // coloca o botão de volta no footer
        finishBtn
        .removeClass('in-form')
        .attr('type', 'button')
        .appendTo(footer);

        footer.removeClass('d-none');
            });
  }

  // ===================== CNPJ Mask & Check =====================


  function bindCnpjMaskAndCheck() {
    const render = $('#cart-subscribe-render');
    let hasInjected = false;
    $(document).on('input', '#cnpj', function() {
      let v = this.value.replace(/\D/g, '');
      if (v.length > 14) v = v.substr(0, 14);
      v = v.replace(/^(\d{2})(\d)/, '$1.$2');
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      v = v.replace(/\.(\d{3})(\d)/, '.$1/$2');
      v = v.replace(/(\d{4})(\d)/, '$1-$2');
      this.value = v;
      const raw = v.replace(/\D/g, '');
      if (raw.length < 14) {
        render.empty(); hasInjected = false;
      } else if (raw.length === 14 && !hasInjected) {
        $.post({ url: baseUrl + '/check-cliente-cart', data: { cnpj_usu: v }, headers: { 'X-CSRF-TOKEN': getCsrf() } })
          .done(resp => {
            render.empty();
            if (resp.success) {
              render.html(
                `<div class="col-12 mt-3">
                    <p class="d-flex align-items-center mb-2 gap-2"><svg class="w-6" fill="currentColor" xmlns="http://www.w3.org/2000/svg" id="mdi-check-circle" viewBox="0 0 24 24"><path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"></path></svg><strong class="me-2">Cliente encontrado:</strong></p>
                    <p>${resp.nome} — ${resp.cnpj}</p>
                 </div>`
              );
            } else {
              render.append(
                `<div class="col-md-12 p-1"><input type="text" class="form-control" name="nome_usu" placeholder="Razão Social"></div>` +
                `<div class="col-md-12 p-1"><input type="email" class="form-control" name="email_usu" placeholder="E-mail"></div>` +
                `<div class="col-md-12 p-1"><input type="text" class="form-control telefone" name="tel_usu" placeholder="Telefone"></div>` +
                `<div class="col-md-12 p-1"><input type="password" class="form-control" name="senha_usu" maxlength="12" placeholder="Senha"></div>`
              );
              // Apply phone mask to the newly injected telefone input
              render.find('.telefone').on('input', function(e) {
                if (e.target.dataset.masking) return;
                e.target.dataset.masking = 'true';
                e.target.value = maskPhone(e.target.value);
                const length = e.target.value.length;
                e.target.setSelectionRange(length, length);
                delete e.target.dataset.masking;
              });
            }
            hasInjected = true;
          })
          .fail(err => console.error('Erro checkCliente:', err));
      }
    });
  }
        // Modal
        // Modal + validação + submit ajax
    function bindFormValidation() {
        $(document).on('submit', '.carrinhoForm', function (e) {
            e.preventDefault(); // Impede o reload da página
            // Para garantir que o evento não propague
            e.stopPropagation();

            let valid = true;

            // Remove classes e mensagens antigas de erro
            $('.form-control').removeClass('is-invalid');
            $('.invalid-feedback').remove();

            // Campos obrigatórios e mensagens
            const requiredFields = [
                { name: 'cnpj_usu', msg: 'CNPJ é obrigatório.' },
                { name: 'nome_usu', msg: 'Razão Social é obrigatória.' },
                { name: 'email_usu', msg: 'E-mail é obrigatório.' },
                { name: 'tel_usu', msg: 'Telefone é obrigatório.' },
                { name: 'senha_usu', msg: 'Senha é obrigatória.' }
            ];

            // Valida os campos obrigatórios
            requiredFields.forEach(f => {
                const inp = $(`[name="${f.name}"]`);
                if (inp.length && !inp.val().trim()) {
                    valid = false;
                    inp.addClass('is-invalid').after(`<div class="invalid-feedback d-block">${f.msg}</div>`);
                }
            });

            if (!valid) return false; // para não enviar se inválido

            const $form = $(this);
            const url = $form.attr('action');
            const data = $form.serialize();

            // Desabilita botão e mostra spinner
            $('.loading').prop('disabled', true).html(
                '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Enviando...'
            );

            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                success: function(resp) {
                    console.log('Resposta de sucesso:', resp);
                    $('.loading').prop('disabled', false).html('Finalizar Orçamento');

                    if (resp.status === 'success') {
                        // Atualiza título do modal de sucesso
                        const titleEl = document.getElementById('ModalTitleSuccess');
                        if (titleEl) titleEl.textContent = 'Sucesso!';

                        // Atualiza corpo do modal de sucesso
                        const modalBody = document.querySelector('#SuccessModal .modal-body');
                        if (modalBody) modalBody.textContent = 'Orçamento finalizado com sucesso!';

                        // Exibe o modal de sucesso com Bootstrap 5 API
                        const successModalEl = document.getElementById('SuccessModal');
                        if (successModalEl) {
                            const successModal = new bootstrap.Modal(successModalEl);
                            successModal.show();
                        }

                        // Fecha o offcanvas do carrinho, se estiver aberto
                        const offcanvasEl = document.getElementById('carrinhoMenu');
                        if (offcanvasEl) {
                            const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl);
                            if (offcanvas) offcanvas.hide();
                        }

                        // Redireciona após delay para o usuário ver o modal
                        setTimeout(function(){
                            window.location.href = resp.redirect;
                        }, 1500);

                    } else {
                        // Modal de erro
                        const errorModalEl = document.getElementById('ErrorModal');
                        if (errorModalEl) {
                            const errorModal = new bootstrap.Modal(errorModalEl);
                            errorModal.show();
                        }
                    }
                },
                error: function (xhr) {
                    console.warn('Erro AJAX:', xhr.status, xhr.responseText);
                    $('.loading').prop('disabled', false).html('Finalizar Orçamento');

                    const errorModalEl = document.getElementById('ErrorModal');
                    if (errorModalEl) {
                        const errorModal = new bootstrap.Modal(errorModalEl);
                        errorModal.show();
                    }
                }
            });

            return false; // para garantir que o submit nativo não aconteça
        });

        // Limpa erros visuais ao digitar no campo inválido
        $(document).on('input', '.form-control.is-invalid', function () {
            $(this).removeClass('is-invalid').next('.invalid-feedback').remove();
        });
    }






  function bindFieldsetToggle() {
    $('input[type=checkbox]').on('change', function() {
      const form = $(this).closest('form');
      const fid = form.attr('id');
      const rec = form.find('.recaptcha').attr('id');
      $(`#${fid} fieldset`).attr('disabled', !this.checked);
      $(`#${rec}`).toggleClass('d-none', !this.checked);
    });
  }

  // ===================== Init =====================
  $(function() {
    refreshCountUI();
    bindAddToCart();
    bindUpdateQuantity();
    bindRemoveItem();
    bindFinishOrc();
    bindCnpjMaskAndCheck();
    bindFormValidation();
    bindFieldsetToggle();
  });

})(jQuery);
